module.exports = __webpack_public_path__ + "img/11.d6a9c9ed.png";